var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("label", { staticClass: "input-label" }, [_vm._v("Title")]),
    _vm._v(" "),
    _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.title,
            expression: "title",
          },
        ],
        staticClass: "form-control form-control-sm optimizely-meta-title-input",
        attrs: { type: "text" },
        domProps: { value: _vm.title },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.title = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.languageDetectorSupported
        ? _c(
            "button",
            {
              staticClass: "btn btn-link btn-sm ml-1",
              attrs: {
                type: "button",
                disabled: _vm.detectingLanguage,
                title: "Detect language and country from instance text",
              },
              on: { click: _vm.detectLanguageAndCountry },
            },
            [
              _c("i", {
                class: _vm.detectingLanguage
                  ? "fa fa-spinner fa-spin"
                  : "fa fa-magic",
              }),
            ]
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.loadingFields
      ? _c("div", { staticClass: "text-center mt-2" }, [
          _c("i", { staticClass: "fa fa-spinner fa-spin" }),
        ])
      : _c(
          "div",
          { staticClass: "row mt-2" },
          _vm._l(_vm.textFields, function (field) {
            return _c("div", { key: field.id, staticClass: "col-md-6 mt-2" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(field.name)),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selected[field.id],
                    expression: "selected[field.id]",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "text" },
                domProps: { value: _vm.selected[field.id] },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.selected, field.id, $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "optimizely-meta-field-input",
                attrs: { type: "hidden", "data-field-id": field.id },
                domProps: { value: _vm.serializeSelection(field) },
              }),
            ])
          }),
          0
        ),
    _vm._v(" "),
    !_vm.loadingFields
      ? _c(
          "div",
          { staticClass: "row mt-2" },
          _vm._l(_vm.dateFields, function (field) {
            return _c("div", { key: field.id, staticClass: "col-md-6 mt-2" }, [
              _c("label", { staticClass: "input-label" }, [
                _vm._v(_vm._s(field.name)),
              ]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.selected[field.id],
                    expression: "selected[field.id]",
                  },
                ],
                staticClass: "form-control",
                attrs: { type: "date" },
                domProps: { value: _vm.selected[field.id] },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.selected, field.id, $event.target.value)
                  },
                },
              }),
              _vm._v(" "),
              _c("input", {
                staticClass: "optimizely-meta-field-input",
                attrs: { type: "hidden", "data-field-id": field.id },
                domProps: { value: _vm.serializeSelection(field) },
              }),
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.loadingFields
      ? _c(
          "div",
          { staticClass: "row mt-2" },
          _vm._l(_vm.selectFields, function (field) {
            return _c(
              "div",
              { key: field.id, staticClass: "col-md-6 mt-2" },
              [
                _c("label", { staticClass: "input-label" }, [
                  _vm._v(_vm._s(field.name)),
                ]),
                _vm._v(" "),
                _c("Multiselect", {
                  attrs: {
                    options: field.choices,
                    multiple: field.is_multi_select,
                    "track-by": "id",
                    label: "name",
                  },
                  model: {
                    value: _vm.selected[field.id],
                    callback: function ($$v) {
                      _vm.$set(_vm.selected, field.id, $$v)
                    },
                    expression: "selected[field.id]",
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  staticClass: "optimizely-meta-field-input",
                  attrs: { type: "hidden", "data-field-id": field.id },
                  domProps: { value: _vm.serializeSelection(field) },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }